import { Link, LinkProps } from '@tanstack/react-router';
import { ComponentType } from 'react';
import styled from 'styled-components';

import { Text } from '../../cdl/Text/Text';
import { Box } from '../ui/Box';
import { theme } from '../ui/theme';

const MenuItemLink = styled(Link)`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 6px;
    border-radius: ${theme.radii[8]};
    text-decoration: none;
    transition: all 0.15s ease;
    cursor: pointer;
    min-width: 348px;

    &:hover,
    &:focus {
        background-color: ${theme.colors.background.inset};
        text-decoration: none;
    }

    &:active,
    &:visited {
        text-decoration: none;
    }
`;

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background-color: ${theme.colors.background.inset};
    color: ${theme.colors.accent.foreground};
    flex-shrink: 0;
`;

interface MenuItemProps {
    title: string;
    description: string;
    Icon: ComponentType<{ width?: number; height?: number }>;
    linkOptions: LinkProps;
}

export const MenuItem = ({ title, description, Icon, linkOptions }: MenuItemProps) => {
    return (
        /* @ts-ignore */
        <MenuItemLink to={linkOptions.to} params={linkOptions.params} search={linkOptions.search}>
            <IconWrapper>
                <Icon width={24} height={24} />
            </IconWrapper>
            <Box display="flex" flexDirection="column" gap={2} flex="1">
                <Text variant="body" color="accent.foreground" fontWeight={600}>
                    {title}
                </Text>
                <Text variant="small">{description}</Text>
            </Box>
        </MenuItemLink>
    );
};
